import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { DataTable, CampusSingleTabVenues, CampusSingleTabGroups, CampusSingleTabUsers, CampusSingleTabStaff, CampusSingleTabSatisfaction, Button, Dialog, EditIcon, Tabs, DialogCampusSingleEditCampus, DialogCampusSingleAddGroup, DialogCampusSingleAddUser, DialogCampusSingleAddStaffTrainer, DialogCampusSingleAddStaffCoordinator, DialogCampusSingleAssignUsersToGroup, DialogImport, ButtonPopover, SwitchStatus, Can, canFunction, LoadingTemplate, ErrorTemplate } from "../../../../";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    box: {
      display: "flex",
      "align-items": "center",
      "border-radius": "4px",
      border: "1px solid #7d7d7d"
    },
    titleCard: {
      textAlign: "center",
      width: "100%",
      margin: "16px 0"
    },
    actionsTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    mt50: {
      marginTop: "50px"
    },
    editIcon: {
      color: "#ffe082",
      marginLeft: "8px",
      cursor: "pointer"
    },
    titleCampus: {
      display: "flex",
      alignItems: "center"
    }
  };
});
var defaultTabs = [{
  value: "venues",
  label: "Venues"
}, {
  value: "groups",
  label: "Groups"
}, {
  value: "users",
  label: "Users"
}, {
  value: "staff",
  label: "Staff"
}];

var WebCampusSingle = function WebCampusSingle(props) {
  var _useState = useState("venues"),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialogAddGroup = _useState4[0],
      setOpenDialogAddGroup = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openDialogAddUser = _useState6[0],
      setOpenDialogAddUser = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openDialogAddStaffTrainer = _useState8[0],
      setOpenDialogAddStaffTrainer = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openDialogAddStaffCoordinator = _useState10[0],
      setOpenDialogAddStaffCoordinator = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      openDialogImportUsers = _useState12[0],
      setOpenDialogImportUsers = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      openDialogEditCampus = _useState14[0],
      setOpenDialogEditCampus = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      openDialogDeleteCampus = _useState16[0],
      setOpenDialogDeleteCampus = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      openDialogAssignUsersToGroup = _useState18[0],
      setOpenDialogAssignUsersToGroup = _useState18[1];

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      assignUsersToGroup = _useState20[0],
      setAssignUsersToGroup = _useState20[1]; //POPOVER LABELS


  var _useState21 = useState([]),
      _useState22 = _slicedToArray(_useState21, 2),
      labelsPopover = _useState22[0],
      setLabelsPopover = _useState22[1];

  var classes = useStyles();
  useEffect(function () {
    var auxLabels = [];
    props.translation && props.translation.popovers && props.translation.popovers.campus && props.translation.popovers.campus.labels.forEach(function (label) {
      canFunction({
        role: props.role,
        perform: label.perform
      }).then(function (x) {
        auxLabels.push(label);
      });
    });
    setLabelsPopover(auxLabels);
  }, [props.translation, props.role]); // FUNCTION POPOVER

  var handleItemPopoverClick = function handleItemPopoverClick(type) {
    switch (type) {
      case "add_group":
        handleModalDialogAddGroup();
        break;

      case "add_user":
        handleModalDialogAddUser();
        break;

      case "import_users":
        handleModalDialogImportUsers();
        break;

      case "add_staff_trainer":
        handleModalDialogAddStaffTrainer();
        break;

      case "add_staff_coordinator":
        handleModalDialogAddStaffCoordinator();
        break;

      default:
        break;
    }
  }; // FUNCTIONS DIALOG


  var handleModalDialogEditCampus = function handleModalDialogEditCampus() {
    if (!openDialogEditCampus) {
      // props.handleDownloadProjects().then((x) => {
      setOpenDialogEditCampus(!openDialogEditCampus); // });
    } else {
      setOpenDialogEditCampus(!openDialogEditCampus);
    }
  };

  var handleModalDialogDeleteCampus = function handleModalDialogDeleteCampus() {
    setOpenDialogDeleteCampus(!openDialogDeleteCampus);
  };

  var handleModalDialogAddGroup = function handleModalDialogAddGroup() {
    setOpenDialogAddGroup(!openDialogAddGroup);
  };

  var handleModalDialogAddUser = function handleModalDialogAddUser() {
    setOpenDialogAddUser(!openDialogAddUser);
  };

  var handleModalDialogAddStaffTrainer = function handleModalDialogAddStaffTrainer() {
    setOpenDialogAddStaffTrainer(!openDialogAddStaffTrainer);
  };

  var handleModalDialogAddStaffCoordinator = function handleModalDialogAddStaffCoordinator() {
    setOpenDialogAddStaffCoordinator(!openDialogAddStaffCoordinator);
  };

  var handleModalDialogImportUsers = function handleModalDialogImportUsers() {
    setOpenDialogImportUsers(!openDialogImportUsers);
  };

  var handleModalDialogAssignUsersToGroup = function handleModalDialogAssignUsersToGroup() {
    setOpenDialogAssignUsersToGroup(!openDialogAssignUsersToGroup);
  }; // FUNCTIONS TAB


  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  }; // FUNCTIONS USERS ASSIGN TO GROUP


  var handleAssignUsersToGroup = function handleAssignUsersToGroup(users) {
    setAssignUsersToGroup(users);
    handleModalDialogAssignUsersToGroup();
  }; // FUNCTIONS LOGIC IMPORT DATA


  var unflatten = function unflatten(data) {
    var result = {};

    var _loop = function _loop(i) {
      var keys = i.split("_");
      keys.reduce(function (r, e, j) {
        return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? keys.length - 1 === j ? data[i] : {} : []);
      }, result);
    };

    for (var i in data) {
      _loop(i);
    }

    return result;
  };

  var importData = function importData(data) {
    handleModalDialogImportUsers();
    props.handleImportUsers(data.map(function (dataObject) {
      return unflatten(dataObject);
    }));
  }; // RENDER TAB CONTENT


  var renderContentTabs = function renderContentTabs() {
    var content;

    switch (value) {
      case "venues":
        content = /*#__PURE__*/React.createElement(CampusSingleTabVenues, {
          activitiesPerVenue: props.activitiesPerVenue,
          activitiesPerGroup: props.activitiesPerGroup,
          translation: props.translation ? props.translation.venues : null,
          handleSubmitModalAddResource: props.handleSubmitModalAddResource,
          handleEditVenue: props.handleEditVenue,
          handleDeleteVenue: props.handleDeleteVenue
        });
        break;

      case "groups":
        content = /*#__PURE__*/React.createElement(CampusSingleTabGroups, {
          groups: props.groups,
          campusId: props.campusId,
          translation: props.translation ? props.translation.groups : null
        });
        break;

      case "users":
        content = /*#__PURE__*/React.createElement(CampusSingleTabUsers, {
          users: props.users,
          translation: props.translation ? props.translation.users : null,
          groups: props.groups,
          handleEditUser: props.handleEditUser,
          handleDeleteUser: props.handleDeleteUser,
          handleAssignUsersToGroup: handleAssignUsersToGroup
        });
        break;

      case "staff":
        content = /*#__PURE__*/React.createElement(CampusSingleTabStaff, {
          role: props.role,
          staff: props.staff,
          translation: props.translation ? props.translation.staff : null,
          groups: props.groups,
          downloadStaffInfo: props.downloadStaffInfo,
          handleEditStaff: props.handleEditStaff,
          handleDeleteStaff: props.handleDeleteStaff,
          handleViewCertificate: props.handleViewCertificate
        });
        break;

      case "satisfaction":
        content = /*#__PURE__*/React.createElement(CampusSingleTabSatisfaction, {
          role: props.role,
          translation: props.translation ? props.translation.satisfaction : null,
          satisfaction: props.satisfaction
        });
        break;

      default:
        content = "";
        break;
    }

    return content;
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    downloading: function downloading() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: "100vh",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(LoadingTemplate, {
        text: props.translation ? props.translation.templates ? props.translation.templates.downloading || "Downloading" : "Downloading" : "Downloading"
      }));
    },
    loading: function loading() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: "100vh",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(LoadingTemplate, {
        text: props.translation ? props.translation.templates ? props.translation.templates.loading || "Loading" : "Loading" : "Loading"
      }));
    },
    error: function error() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: "100vh",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(ErrorTemplate, {
        text: props.translation ? props.translation.templates ? props.translation.templates.error || "Error" : "Error" : "Error"
      }));
    },
    success: function success() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, {
        open: openDialogDeleteCampus,
        onClose: handleModalDialogDeleteCampus,
        title: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_campus ? props.translation.dialogs.delete_campus.title || "Do you want to remove this campus?" : "Do you want to remove this campus?" : "Do you want to remove this campus?" : "Do you want to remove this campus?",
        text: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_campus ? props.translation.dialogs.delete_campus.text || "You will lose all content from this campus" : "You will lose all content from this campus" : "You will lose all content from this campus" : "You will lose all content from this campus",
        submit: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_campus ? props.translation.dialogs.delete_campus.buttons ? props.translation.dialogs.delete_campus.buttons.submit || "Delete" : "Delete" : "Delete" : "Delete" : "Delete",
        buttonColorSubmit: "secondary",
        buttonVariantSubmit: "contained",
        onCancel: handleModalDialogDeleteCampus,
        cancel: props.translation ? props.translation.dialogs ? props.translation.dialogs.delete_campus ? props.translation.dialogs.delete_campus.buttons ? props.translation.dialogs.delete_campus.buttons.cancel || "Cancel" : "Cancel" : "Cancel" : "Cancel" : "Cancel",
        buttonColorCancel: "secondary",
        buttonVariantCancel: "outlined",
        onSubmit: function onSubmit() {
          props.handleDeleteCampus();
          handleModalDialogDeleteCampus();
        }
      }), /*#__PURE__*/React.createElement(DialogCampusSingleEditCampus, {
        open: openDialogEditCampus,
        onClose: handleModalDialogEditCampus,
        onSubmit: props.handleEditCampus,
        projects: props.projects,
        data: props.campusData,
        role: props.role,
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.edit_campus || null : null : null
      }), /*#__PURE__*/React.createElement(DialogCampusSingleAssignUsersToGroup, {
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.assign_users_to_group || null : null : null,
        data: {
          users: assignUsersToGroup
        },
        groups: props.groups,
        open: openDialogAssignUsersToGroup,
        onClose: handleModalDialogAssignUsersToGroup,
        onSubmit: props.handleAssignUsersToGroup
      }), /*#__PURE__*/React.createElement(DialogCampusSingleAddGroup, {
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.add_group || null : null : null,
        open: openDialogAddGroup,
        onClose: handleModalDialogAddGroup,
        onSubmit: props.handleAddGroup
      }), /*#__PURE__*/React.createElement(DialogCampusSingleAddUser, {
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.add_user || null : null : null,
        open: openDialogAddUser,
        onClose: handleModalDialogAddUser,
        onSubmit: props.handleAddUser
      }), /*#__PURE__*/React.createElement(DialogCampusSingleAddStaffTrainer, {
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.add_staff_trainer || null : null : null,
        open: openDialogAddStaffTrainer,
        groups: props.groups,
        sm_staff: props.sm_staff,
        staff: props.staff,
        onClose: handleModalDialogAddStaffTrainer,
        handleDownloadSMStaff: props.handleDownloadSMStaff,
        onSubmit: props.handleAddStaffTrainer
      }), /*#__PURE__*/React.createElement(DialogCampusSingleAddStaffCoordinator, {
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.add_staff_coordinator || null : null : null,
        open: openDialogAddStaffCoordinator,
        groups: props.groups,
        sm_staff: props.sm_staff,
        staff: props.staff,
        onClose: handleModalDialogAddStaffCoordinator,
        handleDownloadSMStaff: props.handleDownloadSMStaff,
        onSubmit: props.handleAddStaffCoordinator
      }), /*#__PURE__*/React.createElement(DialogImport, {
        open: openDialogImportUsers,
        onClose: handleModalDialogImportUsers,
        columnsImport: props.translation ? props.translation.datatables ? props.translation.datatables.import_users || null : null : null,
        titleSheet: "Usuarios",
        options: {
          selectableRows: false
        },
        importData: importData,
        translation: props.translation ? props.translation.dialogs ? props.translation.dialogs.import_users || null : null : null //checked
        ,
        link: "https://plantillas-excell.s3-eu-west-1.amazonaws.com/Manager/20200408_Plantilla_Campus.xlsx"
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 10
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.titleCampus
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h4"
      }, props.campusData ? props.campusData.name || "Campus" : "Campus"), /*#__PURE__*/React.createElement(EditIcon, {
        className: classes.editIcon,
        onClick: handleModalDialogEditCampus
      }), /*#__PURE__*/React.createElement(Can, {
        role: props.role,
        perform: "campus:delete_campus",
        yes: function yes() {
          return /*#__PURE__*/React.createElement(DeleteIcon, {
            color: "secondary",
            className: classes.icon,
            onClick: handleModalDialogDeleteCampus
          });
        },
        no: function no() {
          return null;
        }
      })), /*#__PURE__*/React.createElement(Typography, {
        variant: "h6"
      }, props.campusData ? props.campusData.date && props.campusData.date.start && props.campusData.date.end ? "".concat(moment(props.campusData.date.start).format("DD/MM/YYYY"), "-").concat(moment(props.campusData.date.end).format("DD/MM/YYYY")) : "Sin fecha" : "Sin fecha")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 2,
        className: classes.actionsTitle
      }, /*#__PURE__*/React.createElement(ButtonPopover, {
        labels: labelsPopover,
        handleItemClick: handleItemPopoverClick
      }, props.translation ? props.translation.popovers ? props.translation.popovers.campus ? props.translation.popovers.campus.label || "+ Button" : "+ Button" : "+ Button" : "+ Button")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Tabs, {
        value: value,
        onChange: handleTabs,
        variant: "fullWidth" // className={classes.mb30}
        ,
        indicatorColor: "primary",
        textColor: "primary",
        contentTabs: props.translation ? props.translation.tabs || defaultTabs : defaultTabs
      })), renderContentTabs());
    }
  }));
};

export { WebCampusSingle };